<template><div
    class="modal-dialog"
    @click.self="$emit('close', false)"
    @keydown.esc="$emit('close', true)"
    @keydown.enter="$emit('close', 1)"
    tabindex="0"
    :style="{'z-index':strong?500:300}"
  >
  <div>
    <div class="close" v-if="$listeners.close" @click="$emit('close', true)">X</div>
    <slot>
      Dialog
    </slot>
  </div>
</div></template>
<script>
export default {
  name: 'modal-dialog',
  props: ['strong'],
  mounted() {
    this.$el.focus()
  },
}
</script>
<style lang="scss" scoped>
  .modal-dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
    background-color: rgba(0,0,0,.5);
    display: flex;
    justify-content: center;
    align-items: center;
    > * {
      position: relative;
      background-color: #fff;
      border: 6px double #000;
      border-radius: 15px;
      padding: 20px;
      margin: 20px;
      max-width: calc(100% - 40px);
      box-sizing: border-box;
      .close {
        outline: 0;
        position: absolute;
        top: -18px;
        right: -18px;
        border-radius: 17px;
        border: 2px solid #000;
        width: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #fba !important;
        }
      }
    }
    &:focus {
      .close {
        background-color: #fba;
      }
    }
  }
</style>
